import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import "./FloatingPalette.css"
import { interactionSetEditorState, interactionFloatingPaletteInputEnd } from "../../../../store/interaction";
import { PaletteRefProps } from "../../shapes/line/LineFloatingPalette";
import { getFloatingPalette } from "../../util/shapeCategorySingleton";

const FloatingPalette = () => {
  const dispatch = useAppDispatch();
  const mouse = useAppSelector(state => state.interface.mouseOverMainContainer)
  const toolType = useAppSelector(state => state.tool.currentTool);
  const editorState = useAppSelector((state) => state.interaction.editorState);
  let paletteRef = useRef<PaletteRefProps>(null);

  function mousePosition() {
    return { left: mouse ? mouse.x + 20 : undefined, top: mouse ? mouse.y + 20 : undefined }
  }

  useEffect(() => {
    const handleToggle = (ev: KeyboardEvent) => {
      switch (ev.key) {
        case "Tab":
          ev.preventDefault();
          paletteRef.current?.toggle();
          break;
        case "Escape":
          dispatch(interactionSetEditorState("normal"));
          dispatch(interactionFloatingPaletteInputEnd());
          break;
        case "Backspace": paletteRef.current?.backspace(); break;
        case "1": case "2": case "3": case "4": case "5": case "6": case "7": case "8": case "9": case "0":
          dispatch(interactionSetEditorState("numberInput"));
          paletteRef.current?.onNumberInput(ev.key);
          break;
      }
    }
    window.addEventListener("keydown", handleToggle);
    return () => window.removeEventListener("keydown", handleToggle);
  }, [paletteRef, dispatch])


  return (
    (getFloatingPalette(toolType)!!) &&
    (
      <div className="floating" style={mousePosition()} hidden={editorState !== "numberInput"} >
        {getFloatingPalette(toolType)?.(paletteRef)}
      </div>
    )
  )
}

// interface CircleFloatingPaletteProps {
// }
// const CirlcleFloatingPalette = forwardRef<PaletteRefProps, CircleFloatingPaletteProps>((props, ref) => {
//   useImperativeHandle(ref, () => {
//     return {
//       toggle: () => { },
//       backspace: () => { },
//       onNumberInput: () => { },
//     }
//   })
//   return (<></>)
// })


export default FloatingPalette;